/**
 * @generated SignedSource<<35ab783299fc75219c3bf943e8136b52>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AsyncJcsProjectMenuContent_jiraProject$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JcsProjectMenuContent">;
  readonly " $fragmentType": "AsyncJcsProjectMenuContent_jiraProject";
};
export type AsyncJcsProjectMenuContent_jiraProject$key = {
  readonly " $data"?: AsyncJcsProjectMenuContent_jiraProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"AsyncJcsProjectMenuContent_jiraProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AsyncJcsProjectMenuContent_jiraProject",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "JcsProjectMenuContent"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "633aa77648aa4d621c44a51fe9107db8";

export default node;
